import React, { useState } from 'react';
import classNames from 'classnames';

interface INewUserPasswordInputProps {
    password: string; // Password to appear in the input
    label: string; // Text for the input label
    handleChange: (value: string) => void; // Handle when the user types in the input
    validationError?: boolean; // Show a red border around the element
    children?: JSX.Element; // Any child elements needed to be placed after the input
    classes?: string; // Additional classes to be added to the element
}

/**
 * Standardised password component to be used in the 'new user' flow
 */
const NewUserPasswordInput = ({
    label,
    classes,
    children,
    password,
    handleChange,
    validationError,
}: INewUserPasswordInputProps): JSX.Element => {
    const [showPassword, setShowPassword] = useState<boolean>(false);

    return (
        <div className={`new-user-view-form-group ${classes}`}>
            <label htmlFor="password">{label}</label>
            <div
                className={classNames('new-user-choose-password-input-wrapper', {
                    error: validationError,
                })}
            >
                <input
                    id="password"
                    name="password"
                    autoComplete="off"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={e => {
                        handleChange(e.target.value);
                    }}
                />
                <a
                    href="#"
                    onClick={e => {
                        e.preventDefault();

                        setShowPassword(!showPassword);
                    }}
                >
                    {showPassword ? 'Hide' : 'Show'}
                </a>
            </div>

            {children}
        </div>
    );
};

export default NewUserPasswordInput;
